import { DialogContent, DialogContentText } from "@material-ui/core";
import React from "react";
import { DialogContentErrorText, DialogContentSuccessText } from "../../../../functions/errorHandling";
import WithLoadingSpinners from "../../../hoc/WithLoadingSpinner";

interface ISubmitForProductionDialogContentFirstTimeProps {
  showLoading: boolean;
  preValidateError: string | null | undefined;
  submitError: string | null | undefined;
  successMessage: string | null | undefined;
  message: string;
}

export const SubmitForProductionDialogContent = (props: ISubmitForProductionDialogContentFirstTimeProps) => {
  const { showLoading, preValidateError, submitError, successMessage, message } = props;

  return (
    <DialogContent>
      <WithLoadingSpinners isLoading={showLoading} message={"Submitting Service Call"}>
        <DialogContentText>{message}</DialogContentText>
        {preValidateError && <DialogContentErrorText>{preValidateError}</DialogContentErrorText>}
        {submitError && (
          <>
            <DialogContentErrorText>{submitError}</DialogContentErrorText>
          </>
        )}
        {successMessage && <DialogContentSuccessText>{successMessage}</DialogContentSuccessText>}
      </WithLoadingSpinners>
    </DialogContent>
  );
};
